// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-select {
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_0-select-wrapper {
  /* Typography */
  --perxis-auto-select-font-family-inner: var(
    --perxis-auto-select-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-select-font-size-inner: var(
    --perxis-auto-select-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-select-font-weight-inner: var(
    --perxis-auto-select-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-select-letter-spacing-inner: var(
    --perxis-auto-select-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-select-line-height-inner: var(
    --perxis-auto-select-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-select-text-transform-inner: var(
    --perxis-auto-select-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-select-text-decoration-inner: var(--perxis-auto-select-text-decoration, none);
  --perxis-auto-select-color-inner: var(
    --perxis-auto-select-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-select-disabled-color-inner: var(
    --perxis-auto-select-disabled-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-select-label-font-family-inner: var(
    --perxis-auto-select-label-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-select-label-font-size-inner: var(
    --perxis-auto-select-label-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-select-label-font-weight-inner: var(
    --perxis-auto-select-label-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-select-label-letter-spacing-inner: var(
    --perxis-auto-select-label-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-select-label-line-height-inner: var(
    --perxis-auto-select-label-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-select-label-text-transform-inner: var(
    --perxis-auto-select-label-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-select-label-text-decoration-inner: var(--perxis-auto-select-label-text-decoration, none);
  --perxis-auto-select-label-color-inner: var(
    --perxis-auto-select-label-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-select-label-disabled-color-inner: var(
    --perxis-auto-select-label-disabled-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-select-selection-font-family-inner: var(
    --perxis-auto-select-selection-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-select-multiple-selection-font-family-inner: var(
    --perxis-auto-select-multiple-selection-font-family,
    var(--perxis-auto-select-selection-font-family-inner)
  );
  --perxis-auto-select-selection-font-size-inner: var(
    --perxis-auto-select-selection-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-select-multiple-selection-font-size-inner: var(
    --perxis-auto-select-multiple-selection-font-size,
    var(--perxis-auto-select-selection-font-size-inner)
  );
  --perxis-auto-select-selection-font-weight-inner: var(
    --perxis-auto-select-selection-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-select-multiple-selection-font-weight-inner: var(
    --perxis-auto-select-multiple-selection-font-weight,
    var(--perxis-auto-select-selection-font-weight-inner)
  );
  --perxis-auto-select-selection-letter-spacing-inner: var(
    --perxis-auto-select-selection-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-select-multiple-selection-letter-spacing-inner: var(
    --perxis-auto-select-multiple-selection-letter-spacing,
    var(--perxis-auto-select-selection-letter-spacing-inner)
  );
  --perxis-auto-select-selection-line-height-inner: var(
    --perxis-auto-select-selection-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-select-multiple-selection-line-height-inner: var(
    --perxis-auto-select-multiple-selection-line-height,
    var(--perxis-auto-select-selection-line-height-inner)
  );
  --perxis-auto-select-selection-text-transform-inner: var(
    --perxis-auto-select-selection-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-select-multiple-selection-text-transform-inner: var(
    --perxis-auto-select-selection-text-transform,
    var(--perxis-auto-select-selection-text-transform-inner)
  );
  --perxis-auto-select-selection-font-variant-numeric-inner: var(
    --perxis-auto-select-selection-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  --perxis-auto-select-multiple-selection-font-variant-numeric-inner: var(
    --perxis-auto-select-multiple-selection-font-variant-numeric,
    var(--perxis-auto-select-selection-font-variant-numeric-inner)
  );
  --perxis-auto-select-selection-text-decoration-inner: var(--perxis-auto-select-selection-text-decoration, none);
  --perxis-auto-select-selection-color-inner: var(
    --perxis-auto-select-selection-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-select-multiple-selection-color-inner: var(
    --perxis-auto-select-multiple-selection-color,
    var(--perxis-auto-select-selection-color-inner)
  );
  --perxis-auto-select-selection-hover-color-inner: var(
    --perxis-auto-select-selection-hover-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  --perxis-auto-select-multiple-selection-hover-color-inner: var(
    --perxis-auto-select-multiple-selection-hover-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  --perxis-auto-select-selection-disabled-color-inner: var(
    --perxis-auto-select-selection-disabled-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  --perxis-auto-select-multiple-selection-disabled-color-inner: var(
    --perxis-auto-select-multiple-selection-disabled-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  --perxis-auto-select-arrow-font-size-inner: var(--perxis-auto-select-arrow-font-size, 16px);
  --perxis-auto-select-clear-font-size-inner: var(--perxis-auto-select-clear-font-size, 16px);
  --perxis-auto-select-remove-font-size-inner: var(--perxis-auto-select-remove-font-size, 14px);
  --perxis-auto-select-loading-font-size-inner: var(--perxis-auto-select-loading-font-size, 16px);
  --perxis-auto-select-arrow-color-inner: var(
    --perxis-auto-select-arrow-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-select-hover-arrow-color-inner: var(
    --perxis-auto-select-hover-arrow-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-select-filled-arrow-color-inner: var(
    --perxis-auto-select-filled-arrow-color,
    var(--perxis-auto-select-arrow-color-inner)
  );
  --perxis-auto-select-focus-arrow-color-inner: var(
    --perxis-auto-select-focus-arrow-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-select-disabled-arrow-color-inner: var(
    --perxis-auto-select-disabled-arrow-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-select-clear-color-inner: var(
    --perxis-auto-select-clear-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-select-remove-color-inner: var(
    --perxis-auto-select-remove-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-select-hover-remove-color-inner: var(
    --perxis-auto-select-hover-remove-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  --perxis-auto-select-loading-color-inner: var(
    --perxis-auto-select-loading-color,
    var(--perxis-auto-root-typography-color-light-colorful-inner)
  );
  --perxis-auto-select-placeholder-color-inner: var(
    --perxis-auto-select-placeholder-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-select-placeholder-hover-color-inner: var(
    --perxis-auto-select-placeholder-hover-color,
    var(--perxis-auto-select-placeholder-color-inner)
  );
  --perxis-auto-select-placeholder-filled-color-inner: var(
    --perxis-auto-select-placeholder-filled-color,
    var(--perxis-auto-select-placeholder-color-inner)
  );
  --perxis-auto-select-placeholder-focus-color-inner: var(
    --perxis-auto-select-placeholder-focus-color,
    var(--perxis-auto-select-placeholder-color-inner)
  );
  --perxis-auto-select-placeholder-font-size-inner: var(
    --perxis-auto-select-placeholder-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-select-first-color-inner: var(
    --perxis-auto-select-first-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-select-second-color-inner: var(
    --perxis-auto-select-second-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-select-third-color-inner: var(
    --perxis-auto-select-third-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-select-fourth-color-inner: var(
    --perxis-auto-select-fourth-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-select-fifth-color-inner: var(
    --perxis-auto-select-fifth-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-select-error-color-inner: var(
    --perxis-auto-select-error-color,
    var(--perxis-auto-select-third-color-inner)
  );
  --perxis-auto-select-background-color-inner: var(
    --perxis-auto-select-background-color,
    var(--perxis-auto-select-first-color-inner)
  );
  --perxis-auto-select-hover-background-color-inner: var(
    --perxis-auto-select-hover-background-color,
    var(--perxis-auto-select-first-color-inner)
  );
  --perxis-auto-select-filled-background-color-inner: var(
    --perxis-auto-select-filled-background-color,
    var(--perxis-auto-select-background-color-inner)
  );
  --perxis-auto-select-focus-background-color-inner: var(
    --perxis-auto-select-focus-background-color,
    var(--perxis-auto-select-first-color-inner)
  );
  --perxis-auto-select-disabled-background-color-inner: var(
    --perxis-auto-select-disabled-background-color,
    var(--perxis-auto-select-fourth-color-inner)
  );
  --perxis-auto-select-selection-border-color-inner: var(
    --perxis-auto-select-selection-border-color,
    var(--perxis-auto-select-fourth-color-inner)
  );
  --perxis-auto-select-multiple-selection-border-color-inner: var(
    --perxis-auto-select-multiple-selection-border-color,
    var(--perxis-auto-select-selection-border-color-inner)
  );
  --perxis-auto-select-selection-hover-border-color-inner: var(
    --perxis-auto-select-selection-hover-border-color,
    var(--perxis-auto-select-third-color-inner)
  );
  --perxis-auto-select-multiple-selection-hover-border-color-inner: var(
    --perxis-auto-select-multiple-selection-hover-border-color,
    var(--perxis-auto-select-third-color-inner)
  );
  --perxis-auto-select-selection-disabled-border-color-inner: var(
    --perxis-auto-select-selection-disabled-border-color,
    var(--perxis-auto-select-fourth-color-inner)
  );
  --perxis-auto-select-multiple-selection-disabled-border-color-inner: var(
    --perxis-auto-select-multiple-selection-disabled-border-color,
    var(--perxis-auto-select-fourth-color-inner)
  );
  --perxis-auto-select-selection-background-color-inner: var(
    --perxis-auto-select-selection-background-color,
    var(--perxis-auto-select-fourth-color-inner)
  );
  --perxis-auto-select-multiple-selection-background-color-inner: var(
    --perxis-auto-select-multiple-selection-background-color,
    var(--perxis-auto-select-selection-background-color-inner)
  );
  --perxis-auto-select-selection-hover-background-color-inner: var(
    --perxis-auto-select-selection-hover-background-color,
    var(--perxis-auto-select-third-color-inner)
  );
  --perxis-auto-select-multiple-selection-hover-background-color-inner: var(
    --perxis-auto-select-multiple-selection-hover-background-color,
    var(--perxis-auto-select-third-color-inner)
  );
  --perxis-auto-select-selection-disabled-background-color-inner: var(
    --perxis-auto-select-selection-disabled-background-color,
    var(--perxis-auto-select-fifth-color-inner)
  );
  --perxis-auto-select-multiple-selection-disabled-background-color-inner: var(
    --perxis-auto-select-multiple-selection-disabled-background-color,
    var(--perxis-auto-select-fifth-color-inner)
  );
  --perxis-auto-select-border-color-inner: var(
    --perxis-auto-select-border-color,
    var(--perxis-auto-select-fifth-color-inner)
  );
  --perxis-auto-select-hover-border-color-inner: var(
    --perxis-auto-select-hover-border-color,
    var(--perxis-auto-select-second-color-inner)
  );
  --perxis-auto-select-filled-border-color-inner: var(
    --perxis-auto-select-filled-border-color,
    var(--perxis-auto-select-border-color-inner)
  );
  --perxis-auto-select-focus-border-color-inner: var(
    --perxis-auto-select-focus-border-color,
    var(--perxis-auto-select-second-color-inner)
  );
  --perxis-auto-select-disabled-border-color-inner: var(
    --perxis-auto-select-disabled-border-color,
    var(--perxis-auto-select-fifth-color-inner)
  );
  --perxis-auto-select-borderless-border-color-inner: var(
    --perxis-auto-select-borderless-border-color,
    var(--perxis-auto-select-second-color-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-select-border-radius-inner: var(--perxis-auto-select-border-radius, 8px);
  --perxis-auto-select-border-width-inner: var(--perxis-auto-select-border-width, 2px);
  --perxis-auto-select-border-style-inner: var(--perxis-auto-select-border-style, solid);
  --perxis-auto-select-focus-border-width-inner: var(
    --perxis-auto-select-focus-border-width,
    var(--perxis-auto-select-border-width-inner)
  );
  --perxis-auto-select-borderless-border-radius-inner: var(--perxis-auto-select-borderless-border-radius, 0px);
  --perxis-auto-select-borderless-border-width-inner: var(--perxis-auto-select-borderless-border-width, 0px);
  --perxis-auto-select-borderless-border-style-inner: var(--perxis-auto-select-borderless-border-style, solid);
  --perxis-auto-select-selection-border-radius-inner: var(--perxis-auto-select-selection-border-radius, 0px);
  --perxis-auto-select-multiple-selection-border-radius-inner: var(
    --perxis-auto-select-multiple-selection-radius,
    4px
  );
  --perxis-auto-select-selection-border-width-inner: var(--perxis-auto-select-selection-border-width, 0);
  --perxis-auto-select-multiple-selection-border-width-inner: var(--perxis-auto-select-multiple-selection-width, 1px);
  --perxis-auto-select-selection-border-style-inner: var(--perxis-auto-select-selection-border-style, solid);
  --perxis-auto-select-multiple-selection-border-style-inner: var(
    --perxis-auto-select-multiple-selection-border-style,
    solid
  );
  /* End Border */
  /* Padding */
  --perxis-auto-select-padding-inner: var(--perxis-auto-select-padding, 0 40px 0 15px);
  --perxis-auto-select-multiple-selection-padding-inline-inner: var(
    --perxis-auto-select-multiple-selection-padding-inline,
    8px 5px
  );
  --perxis-auto-select-multiple-selection-padding-inner: var(
    --perxis-auto-select-multiple-selection-padding,
    5px 8px
  );
  /* End Padding */
  /* Margin */
  --perxis-auto-select-multiple-selection-margin-inline-inner: var(
    --perxis-auto-select-multiple-selection-margin-inline,
    0 5px
  );
  --perxis-auto-select-multiple-selection-margin-inner: var(
    --perxis-auto-select-multiple-selection-margin,
    2px 5px 2px 0
  );
  --perxis-auto-select-arrow-margin-top-inner: var(--perxis-auto-select-arrow-margin-top, -8px);
  --perxis-auto-select-clear-margin-top-inner: var(--perxis-auto-select-clear-margin-top, -8px);
  /* End Margin */
}
.perxis-auto-1_16_0-select[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_0-select > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_0-select .ant-5_17_0-wave {
  transition: none !important;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.perxis-auto-1_16_0-select-label {
  --perxis-auto-typography-main-font-family: var(--perxis-auto-select-label-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-select-label-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-select-label-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-select-label-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-select-label-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-select-label-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-select-label-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-select-label-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-select-label-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-select-label-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-select-label-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-select-label-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-select-label-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-select-label-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-select-label-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-select-label-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-select-label-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-select-label-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-select-label-line-height-inner);
}
.perxis-auto-1_16_0-select-label.perxis-auto-1_16_0-typography.perxis-auto-1_16_0-paragraph {
  margin-bottom: 8px;
}
.perxis-auto-1_16_0-select-wrapper {
  position: relative;
}
.perxis-auto-1_16_0-select-wrapper--disabled .perxis-auto-1_16_0-select-label {
  --perxis-auto-typography-color-darkest: var(--perxis-auto-select-label-disabled-color-inner);
}
.perxis-auto-1_16_0-select.perxis-auto-1_16_0-select-filled .ant-5_17_0-select-selector {
  background-color: var(--perxis-auto-select-filled-background-color-inner) !important;
  border-color: var(--perxis-auto-select-filled-border-color-inner) !important;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select {
  position: relative;
  display: block;
  height: auto;
  font-family: var(--perxis-auto-select-font-family-inner);
  font-size: var(--perxis-auto-select-font-size-inner);
  line-height: var(--perxis-auto-select-line-height-inner);
  font-weight: var(--perxis-auto-select-font-weight-inner);
  text-transform: var(--perxis-auto-select-text-transform-inner);
  text-decoration: var(--perxis-auto-select-text-decoration-inner);
  letter-spacing: var(--perxis-auto-select-letter-spacing-inner);
  color: var(--perxis-auto-select-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select.ant-5_17_0-select-disabled .ant-5_17_0-select-selection-item {
  color: var(--perxis-auto-select-disabled-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):hover .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):hover .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-selector {
  background-color: var(--perxis-auto-select-hover-background-color-inner);
  border-color: var(--perxis-auto-select-hover-border-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):hover .ant-5_17_0-select-arrow, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-arrow, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):hover .ant-5_17_0-select-arrow, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-arrow {
  color: var(--perxis-auto-select-hover-arrow-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):hover .ant-5_17_0-select-arrow svg, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-arrow svg, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):hover .ant-5_17_0-select-arrow svg, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-arrow svg {
  fill: var(--perxis-auto-select-hover-arrow-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):hover .ant-5_17_0-select-selection-placeholder, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-selection-placeholder, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):hover .ant-5_17_0-select-selection-placeholder, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-selection-placeholder {
  color: var(--perxis-auto-select-placeholder-hover-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):focus .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):active .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):focus .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):active .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-selector {
  background-color: var(--perxis-auto-select-focus-background-color-inner);
  border-width: var(--perxis-auto-select-focus-border-width-inner);
  border-color: var(--perxis-auto-select-focus-border-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):focus .ant-5_17_0-select-arrow, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):active .ant-5_17_0-select-arrow, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-arrow, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):focus .ant-5_17_0-select-arrow, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):active .ant-5_17_0-select-arrow, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-arrow {
  color: var(--perxis-auto-select-focus-arrow-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):focus .ant-5_17_0-select-arrow svg, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):active .ant-5_17_0-select-arrow svg, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-arrow svg, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):focus .ant-5_17_0-select-arrow svg, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):active .ant-5_17_0-select-arrow svg, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-arrow svg {
  fill: var(--perxis-auto-select-focus-arrow-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):focus .ant-5_17_0-select-selection-placeholder, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled):active .ant-5_17_0-select-selection-placeholder, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-selection-placeholder, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):focus .ant-5_17_0-select-selection-placeholder, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled):active .ant-5_17_0-select-selection-placeholder, .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-disabled).ant-5_17_0-select-focused .ant-5_17_0-select-selection-placeholder {
  color: var(--perxis-auto-select-placeholder-focus-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input).ant-5_17_0-select-single .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select.ant-5_17_0-select-single .ant-5_17_0-select-selector {
  height: auto;
  padding: var(--perxis-auto-select-padding-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input).ant-5_17_0-select-disabled .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select.ant-5_17_0-select-disabled .ant-5_17_0-select-selector {
  background-color: var(--perxis-auto-select-disabled-background-color-inner);
  color: var(--perxis-auto-select-disabled-color-inner);
  border-color: var(--perxis-auto-select-disabled-border-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input).ant-5_17_0-select-disabled .ant-5_17_0-select-arrow, .perxis-auto-1_16_0-select.ant-5_17_0-select.ant-5_17_0-select-disabled .ant-5_17_0-select-arrow {
  color: var(--perxis-auto-select-disabled-arrow-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input).ant-5_17_0-select-disabled .ant-5_17_0-select-arrow svg, .perxis-auto-1_16_0-select.ant-5_17_0-select.ant-5_17_0-select-disabled .ant-5_17_0-select-arrow svg {
  fill: var(--perxis-auto-select-disabled-arrow-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input).ant-5_17_0-select-borderless .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select.ant-5_17_0-select-borderless .ant-5_17_0-select-selector {
  border-style: var(--perxis-auto-select-borderless-border-style-inner);
  border-width: var(--perxis-auto-select-borderless-border-width-inner);
  border-color: var(--perxis-auto-select-borderless-border-color-inner);
  border-radius: var(--perxis-auto-select-borderless-border-radius-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input) .ant-5_17_0-select-selector, .perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-selector {
  height: auto;
  width: auto;
  min-height: 50px;
  box-shadow: none !important;
  border-width: var(--perxis-auto-select-border-width-inner);
  border-style: var(--perxis-auto-select-border-style-inner);
  border-color: var(--perxis-auto-select-border-color-inner);
  border-radius: var(--perxis-auto-select-border-radius-inner);
  background-color: var(--perxis-auto-select-background-color-inner);
  padding: var(--perxis-auto-select-padding-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input) .ant-5_17_0-select-selector .ant-5_17_0-select-selection-search-input,
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input) .ant-5_17_0-select-selector input, .perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-selector .ant-5_17_0-select-selection-search-input,
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-selector input {
  width: 100%;
  height: 100%;
  font-family: var(--perxis-auto-select-font-family-inner);
  line-height: var(--perxis-auto-select-line-height-inner);
  font-weight: var(--perxis-auto-select-font-weight-inner);
  text-transform: var(--perxis-auto-select-text-transform-inner);
  letter-spacing: var(--perxis-auto-select-letter-spacing-inner);
}
@supports (-webkit-touch-callout: none) {
  .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input) .ant-5_17_0-select-selector .ant-5_17_0-select-selection-search-input,
  .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input) .ant-5_17_0-select-selector input, .perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-selector .ant-5_17_0-select-selection-search-input,
  .perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-selector input {
    font-size: max(var(--perxis-auto-select-font-size-inner), 16px);
  }
}
@supports not (-webkit-touch-callout: none) {
  .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input) .ant-5_17_0-select-selector .ant-5_17_0-select-selection-search-input,
  .perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input) .ant-5_17_0-select-selector input, .perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-selector .ant-5_17_0-select-selection-search-input,
  .perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-selector input {
    font-size: var(--perxis-auto-select-font-size-inner);
  }
}
.perxis-auto-1_16_0-select.ant-5_17_0-select:not(.ant-5_17_0-select-multiple) .ant-5_17_0-select-selection-search {
  inset-inline-start: 15px;
  inset-inline-end: 35px;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-selector .ant-5_17_0-select-selection-placeholder {
  color: var(--perxis-auto-select-placeholder-color-inner);
  font-size: var(--perxis-auto-select-placeholder-font-size-inner);
  align-self: center;
  right: 15px;
  left: 15px;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-selector .ant-5_17_0-select-selection-item {
  font-family: var(--perxis-auto-select-selection-font-family-inner);
  font-size: var(--perxis-auto-select-selection-font-size-inner);
  line-height: var(--perxis-auto-select-selection-line-height-inner);
  font-weight: var(--perxis-auto-select-selection-font-weight-inner);
  text-transform: var(--perxis-auto-select-selection-text-transform-inner);
  text-decoration: var(--perxis-auto-select-selection-text-decoration-inner);
  letter-spacing: var(--perxis-auto-select-selection-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-select-selection-font-variant-numeric-inner);
  color: var(--perxis-auto-select-color-inner);
  border-width: var(--perxis-auto-select-selection-border-width-inner);
  border-style: var(--perxis-auto-select-selection-border-style-inner);
  border-color: var(--perxis-auto-select-selection-border-color-inner);
  border-radius: var(--perxis-auto-select-selection-border-radius-inner);
  align-self: center;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select.ant-5_17_0-select-open .ant-5_17_0-select-arrow {
  transform: rotate(-180deg);
  transform-origin: 50% 50%;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-clear {
  right: 18px;
  top: 50%;
  transition: transform 0.2s;
  margin-top: var(--perxis-auto-select-clear-margin-top-inner);
  width: auto;
  height: 18px;
  color: var(--perxis-auto-select-clear-color-inner);
  font-size: var(--perxis-auto-select-clear-font-size-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-select-clear-font-size-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-clear svg {
  fill: var(--perxis-auto-select-clear-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-arrow {
  right: 18px;
  top: 50%;
  transition: transform 0.2s;
  margin-top: var(--perxis-auto-select-arrow-margin-top-inner);
  height: initial;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-arrow:not(.ant-5_17_0-select-arrow-loading) {
  color: var(--perxis-auto-select-arrow-color-inner);
  font-size: var(--perxis-auto-select-arrow-font-size-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-select-arrow-font-size-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-arrow:not(.ant-5_17_0-select-arrow-loading) svg {
  fill: var(--perxis-auto-select-arrow-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-arrow.ant-5_17_0-select-arrow-loading {
  height: var(--perxis-auto-select-loading-font-size-inner);
  width: var(--perxis-auto-select-loading-font-size-inner);
  border-radius: 50%;
  border: 1px solid transparent;
  border-color: var(--perxis-auto-select-loading-color-inner) transparent var(--perxis-auto-select-loading-color-inner) transparent;
  top: 45%;
  animation: lds-dual-ring 1.2s linear infinite;
  color: var(--perxis-auto-select-loading-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-arrow.ant-5_17_0-select-arrow-loading svg {
  opacity: 0;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-arrow.ant-5_17_0-select-arrow-loading > * {
  display: none;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select .ant-5_17_0-select-status-error:not(.ant-5_17_0-select-disabled):not(.ant-5_17_0-select-customize-input):not(.ant-5_17_0-pagination-size-changer) .ant-5_17_0-select-selector {
  background-color: var(--perxis-auto-select-background-color-inner);
  border-color: var(--perxis-auto-select-error-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-show-search:not(.ant-5_5_2-select-customize-input) .ant-5_17_0-select-selector {
  cursor: pointer;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple.ant-5_17_0-select-disabled .ant-5_17_0-select-selector .ant-5_17_0-select-selection-item, .perxis-auto-1_16_0-select.ant-5_17_0-select-multiple .ant-5_17_0-select-selector .ant-5_17_0-select-selection-item.ant-5_17_0-select-selection-item-disabled {
  background-color: var(--perxis-auto-select-multiple-selection-disabled-background-color-inner);
  color: var(--perxis-auto-select-multiple-selection-disabled-color-inner);
  border-color: var(--perxis-auto-select-multiple-selection-disabled-border-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple.ant-5_17_0-select-disabled .ant-5_17_0-select-selector .ant-5_17_0-select-selection-item > .ant-5_17_0-select-selection-item-content, .perxis-auto-1_16_0-select.ant-5_17_0-select-multiple .ant-5_17_0-select-selector .ant-5_17_0-select-selection-item.ant-5_17_0-select-selection-item-disabled > .ant-5_17_0-select-selection-item-content {
  margin-right: 0;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple:not(.ant-5_17_0-select-disabled) .ant-5_17_0-select-selection-item:hover:not(.ant-5_17_0-select-selection-item-disabled) {
  background-color: var(--perxis-auto-select-multiple-selection-hover-background-color-inner);
  color: var(--perxis-auto-select-multiple-selection-hover-color-inner);
  border-color: var(--perxis-auto-select-multiple-selection-hover-border-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple:not(.ant-5_17_0-select-disabled) .ant-5_17_0-select-selection-item:hover:not(.ant-5_17_0-select-selection-item-disabled) .ant-5_17_0-select-selection-item-remove {
  color: var(--perxis-auto-select-hover-remove-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple:not(.ant-5_17_0-select-disabled) .ant-5_17_0-select-selection-item:hover:not(.ant-5_17_0-select-selection-item-disabled) .ant-5_17_0-select-selection-item-remove svg {
  fill: var(--perxis-auto-select-hover-remove-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple .ant-5_17_0-select-selector .ant-5_17_0-select-selection-overflow {
  flex-wrap: nowrap;
  overflow: hidden;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple .ant-5_17_0-select-selector .ant-5_17_0-select-selection-item {
  display: inline-flex;
  align-items: center;
  height: auto;
  font-family: var(--perxis-auto-select-multiple-selection-font-family-inner);
  font-size: var(--perxis-auto-select-multiple-selection-font-size-inner);
  line-height: var(--perxis-auto-select-multiple-selection-line-height-inner);
  font-weight: var(--perxis-auto-select-multiple-selection-font-weight-inner);
  text-transform: var(--perxis-auto-select-multiple-selection-text-transform-inner);
  letter-spacing: var(--perxis-auto-select-multiple-selection-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-select-multiple-selection-font-variant-numeric-inner);
  color: var(--perxis-auto-select-multiple-selection-color-inner);
  background: var(--perxis-auto-select-multiple-selection-background-color-inner);
  border-style: var(--perxis-auto-select-multiple-selection-border-style-inner);
  border-width: var(--perxis-auto-select-multiple-selection-border-width-inner);
  border-color: var(--perxis-auto-select-multiple-selection-border-color-inner);
  border-radius: var(--perxis-auto-select-multiple-selection-border-radius-inner);
  margin-inline: var(--perxis-auto-select-multiple-selection-margin-inline-inner);
  padding-inline: var(--perxis-auto-select-multiple-selection-padding-inline-inner);
  margin: var(--perxis-auto-select-multiple-selection-margin-inner);
  padding: var(--perxis-auto-select-multiple-selection-padding-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple .ant-5_17_0-select-selector .ant-5_17_0-select-selection-item .ant-5_17_0-select-selection-item-remove {
  display: inline-flex;
  color: var(--perxis-auto-select-remove-color-inner);
  font-size: var(--perxis-auto-select-remove-font-size-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-select-remove-font-size-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple .ant-5_17_0-select-selector .ant-5_17_0-select-selection-item .ant-5_17_0-select-selection-item-remove svg {
  fill: var(--perxis-auto-select-remove-color-inner);
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple .ant-5_17_0-select-selector .ant-5_17_0-select-selection-item .ant-5_17_0-select-selection-item-content {
  margin-right: 7px;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-multiple .ant-5_17_0-select-selector .ant-5_17_0-select-selection-search {
  margin-inline-start: 0;
}
.perxis-auto-1_16_0-select.ant-5_17_0-select-status-error.ant-5_17_0-select:not(.ant-5_17_0-select-customize-input) .ant-5_17_0-select-selector {
  border-color: var(--perxis-auto-select-error-color-inner) !important;
}

.perxis-auto-1_16_0-select-dropdown {
  /* Typography */
  --perxis-auto-select-dropdown-font-family-inner: var(
    --perxis-auto-select-dropdown-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-select-dropdown-font-size-inner: var(
    --perxis-auto-select-dropdown-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-select-dropdown-font-variant-numeric-inner: var(
    --perxis-auto-select-dropdown-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  --perxis-auto-select-dropdown-font-weight-inner: var(
    --perxis-auto-select-dropdown-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-select-dropdown-hover-font-weight-inner: var(
    --perxis-auto-select-dropdown-hover-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-select-dropdown-selected-font-weight-inner: var(
    --perxis-auto-select-dropdown-selected-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-select-dropdown-disabled-font-weight-inner: var(
    --perxis-auto-select-dropdown-disabled-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-select-dropdown-letter-spacing-inner: var(
    --perxis-auto-select-dropdown-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-select-dropdown-line-height-inner: var(
    --perxis-auto-select-dropdown-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-select-dropdown-text-transform-inner: var(
    --perxis-auto-select-dropdown-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-select-dropdown-text-decoration-inner: var(--perxis-auto-select-dropdown-text-decoration, none);
  --perxis-auto-select-dropdown-color-inner: var(
    --perxis-auto-select-dropdown-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-select-dropdown-hover-color-inner: var(
    --perxis-auto-select-dropdown-hover-color,
    var(--perxis-auto-root-typography-color-light-colorful-inner)
  );
  --perxis-auto-select-dropdown-selected-color-inner: var(
    --perxis-auto-select-dropdown-selected-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-select-dropdown-disabled-color-inner: var(
    --perxis-auto-select-dropdown-disabled-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-select-dropdown-icon-color-inner: var(
    --perxis-auto-select-dropdown-icon-color,
    var(--perxis-auto-root-typography-color-light-colorful-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-select-dropdown-first-color-inner: var(
    --perxis-auto-select-dropdown-first-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-select-dropdown-second-color-inner: var(
    --perxis-auto-select-dropdown-second-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-select-dropdown-third-color-inner: var(
    --perxis-auto-select-dropdown-third-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-select-dropdown-fourth-color-inner: var(
    --perxis-auto-select-dropdown-fourth-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-select-dropdown-background-color-inner: var(
    --perxis-auto-select-dropdown-background-color,
    var(--perxis-auto-select-dropdown-first-color-inner)
  );
  --perxis-auto-select-dropdown-hover-background-color-inner: var(
    --perxis-auto-select-dropdown-hover-background-color,
    var(--perxis-auto-select-dropdown-fourth-color-inner)
  );
  --perxis-auto-select-dropdown-selected-background-color-inner: var(
    --perxis-auto-select-dropdown-selected-background-color,
    var(--perxis-auto-select-dropdown-fourth-color-inner)
  );
  --perxis-auto-select-dropdown-disabled-background-color-inner: var(
    --perxis-auto-select-dropdown-disabled-background-color,
    var(--perxis-auto-select-select-dropdown-color-inner)
  );
  --perxis-auto-select-dropdown-scrollbar-background-color-inner: var(
    --perxis-auto-select-dropdown-scrollbar-background-color,
    var(--perxis-auto-select-dropdown-third-color-inner)
  );
  --perxis-auto-select-dropdown-scrollbar-thumb-background-color-inner: var(
    --perxis-auto-select-dropdown-scrollbar-thumb-background-color,
    var(--perxis-auto-select-dropdown-second-color-inner)
  );
  --perxis-auto-select-dropdown-border-color-inner: var(
    --perxis-auto-select-dropdown-border-color,
    var(--perxis-auto-root-second-color-inner)
  );
  /* End Colors */
  /* Borders */
  --perxis-auto-select-dropdown-border-radius-inner: var(--perxis-auto-select-dropdown-border-radius, 8px);
  --perxis-auto-select-dropdown-border-width-inner: var(--perxis-auto-select-dropdown-border-width, 0px);
  --perxis-auto-select-dropdown-border-style-inner: var(--perxis-auto-select-dropdown-border-style, solid);
  /* End Borders */
  /* Padding */
  --perxis-auto-select-dropdown-item-padding-inner: var(--perxis-auto-select-dropdown-item-padding, 6px 15px);
  /* End Padding */
  /* Sizes */
  --perxis-auto-select-dropdown-item-min-height-inner: var(--perxis-auto-select-dropdown-item-min-height, 34px);
  /* End Sizes */
  /* Z-index */
  --perxis-auto-select-dropdown-z-index-inner: var(--perxis-auto-select-dropdown-z-index, 1030);
  /* End Z-index */
}
.perxis-auto-1_16_0-select-dropdown.ant-5_17_0-select-dropdown {
  color: var(--perxis-auto-select-dropdown-color-inner);
  border-style: var(--perxis-auto-select-dropdown-border-style-inner);
  border-width: var(--perxis-auto-select-dropdown-border-width-inner);
  border-color: var(--perxis-auto-select-dropdown-border-color-inner);
  background-color: var(--perxis-auto-select-dropdown-background-color-inner);
  border-radius: var(--perxis-auto-select-dropdown-border-radius-inner) !important;
  z-index: var(--perxis-auto-select-dropdown-z-index-inner);
  padding: 0;
}
.perxis-auto-1_16_0-select-dropdown .rc-virtual-list .ant-5_17_0-select-item-option-active:not(.ant-5_17_0-select-item-option-disabled) {
  background-color: transparent;
}
.perxis-auto-1_16_0-select-dropdown .rc-virtual-list .ant-5_17_0-select-item-option:not(.ant-5_17_0-select-item-option-disabled):hover,
.perxis-auto-1_16_0-select-dropdown .rc-virtual-list .ant-5_17_0-select-item-option-active:not(.ant-5_17_0-select-item-option-disabled):hover {
  background-color: var(--perxis-auto-select-dropdown-hover-background-color-inner);
  color: var(--perxis-auto-select-dropdown-hover-color-inner);
}
.perxis-auto-1_16_0-select-dropdown .rc-virtual-list .ant-5_17_0-select-item-option-selected,
.perxis-auto-1_16_0-select-dropdown .rc-virtual-list .ant-5_17_0-select-item-option-selected .rc-virtual-list .ant-5_17_0-select-item-option-selected.ant-5_17_0-select-item-option-active {
  font-weight: var(--perxis-auto-select-dropdown-selected-font-weight-inner);
  background-color: var(--perxis-auto-select-dropdown-selected-background-color-inner);
  color: var(--perxis-auto-select-dropdown-selected-color-inner);
}
.perxis-auto-1_16_0-select-dropdown .ant-5_17_0-select-item-option-selected:not(.ant-5_17_0-select-item-option-disabled) .ant-5_17_0-select-item-option-state {
  color: var(--perxis-auto-select-dropdown-icon-color-inner);
}
.perxis-auto-1_16_0-select-dropdown .ant-5_17_0-select-item-option.ant-5_17_0-select-item-option-disabled {
  background-color: var(--perxis-auto-select-dropdown-disabled-background-color-inner);
  color: var(--perxis-auto-select-dropdown-disabled-color-inner);
  font-weight: var(--perxis-auto-select-dropdown-disabled-font-weight-inner);
}
.perxis-auto-1_16_0-select-dropdown .ant-5_17_0-select-item {
  padding: var(--perxis-auto-select-dropdown-item-padding-inner);
  box-sizing: border-box;
  min-height: var(--perxis-auto-select-dropdown-item-min-height-inner);
  border-radius: 0;
}
.perxis-auto-1_16_0-select-dropdown .ant-5_17_0-select-item-option {
  display: flex;
  align-items: center;
  font-family: var(--perxis-auto-select-dropdown-font-family-inner);
  font-size: var(--perxis-auto-select-dropdown-font-size-inner);
  line-height: var(--perxis-auto-select-dropdown-line-height-inner);
  font-weight: var(--perxis-auto-select-dropdown-font-weight-inner);
  text-transform: var(--perxis-auto-select-dropdown-text-transform-inner);
  text-decoration: var(--perxis-auto-select-dropdown-text-decoration-inner);
  letter-spacing: var(--perxis-auto-select-dropdown-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-select-dropdown-font-variant-numeric-inner);
  color: var(--perxis-auto-select-dropdown-color-inner);
}
.perxis-auto-1_16_0-select-dropdown .rc-virtual-list-scrollbar {
  background: var(--perxis-auto-select-dropdown-scrollbar-background-color-inner) !important;
  width: 8px !important;
}
.perxis-auto-1_16_0-select-dropdown .rc-virtual-list-scrollbar-thumb {
  background: var(--perxis-auto-select-dropdown-scrollbar-thumb-background-color-inner) !important;
  border-radius: 0 !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
